import { css } from '@emotion/css';

import {
  Colors,
  FontSize,
  FontWeight,
  Spacing,
} from 'apps/shared/scripts/styles/constants';

export const buttonClassName = css({
  border: `1px solid ${Colors.LightGray}`,
  color: Colors.Primary,
  fontSize: FontSize.COMPACT,
  fontWeight: FontWeight.SEMI_BOLD,
  minHeight: 42,
  padding: `${Spacing.XS}px ${Spacing.MD}px`,
  '&:hover': {
    background: Colors.Gray,
  },
});

export const iconClassName = css({
  color: Colors.Secondary,
  height: 14,
  width: 14,
});

export const rightHeaderClassName = css({
  display: 'flex',
  gap: Spacing.SM,
});

export const menuClassName = css({
  minWidth: 330,
  padding: Spacing.SM,
});
